<template>
    <ProductTypesList/>
</template>

<script>
import ProductTypesList from '../../components/products/ProductTypesList';

export default {
  components: {
    ProductTypesList,
  },
};
</script>
